import Axios from 'axios';
import FileSaver from 'file-saver';
import { resolveUrl } from '../../../../../utils/resolveUrl';
import { setPreloader } from '../../../../../utils/setPreloader';
import { getProductData } from '../../../utils/data';
import { stickProductDescriptionBlock } from '../../../product-description/product-description';
import { isNotDesktop } from '../../../../../utils/isNotDesktop';

const productDescriptionElement = document.querySelector('.product-description-wrapper');

const STICKED_PRODUCT_INFO = 'product-description-block__sticked';

const afterPrint = callback => {
    setTimeout(() => {
        document.body.classList.remove('print_tech_spec');
        if (callback) {
            callback();
            if (!isNotDesktop()) {
                stickProductDescriptionBlock();
            }
        }
    }, 1000);
};

const mediaPrint = window.matchMedia('print');

const print = () => {
    document.body.classList.add('print_tech_spec');
    productDescriptionElement.classList.remove(STICKED_PRODUCT_INFO);
    window.print();
};

export const init = ({ callbackAfterPrint }) => {
    const printButton = document.querySelector('.fast-action__name_print');

    if (printButton) {
        printButton.addEventListener('click', print);
    }
    window.onafterprint = () => {
        afterPrint(callbackAfterPrint);
    };
    mediaPrint.addListener(e => {
        if (!e.matches) {
            afterPrint(callbackAfterPrint);
        }
    });
    const downloadLink = document.querySelector('.fast-action__name_download');
    if (downloadLink) {
        const addQueryParam = ([queryParam, className]) => {
            const pageElement = document.querySelector(
                `.product-description__price-section ${className}`
            );
            return pageElement ? `&${queryParam}=${encodeURIComponent(pageElement.innerText)}` : '';
        };
        let requestURL = `technical-specification/?skuId=${getProductData().skuId}`;
        requestURL = [
            ['price', '.price-label'],
            ['crossedPrice', '.crossed-out-price-label'],
            ['tradeUpsLabel', '.tradeups-price-label'],
            ['resellerLabel', '.reseller-price-label'],
        ].reduce((query, element) => {
            query += addQueryParam(element);
            return query;
        }, requestURL);

        downloadLink.addEventListener('click', async () => {
            downloadLink.classList.add('fast-action_loading');
            const preloader = setPreloader(downloadLink.querySelector('.fast-action__preloader'));
            try {
                const response = await Axios({
                    url: resolveUrl(requestURL),
                    method: 'GET',
                    responseType: 'blob',
                });

                const responsePDF = new Blob([response.data], { type: 'application/pdf' });
                const contentDispositionHeader = response.headers['content-disposition'];
                const titlePDF = contentDispositionHeader
                    .split(';')[1]
                    .trim()
                    .split('=')[1];

                FileSaver.saveAs(responsePDF, titlePDF.replace(/"/g, ''));
            } catch (error) {
                // eslint-disable-next-line
                console.warn(error);
            } finally {
                preloader.destroy();
                downloadLink.classList.remove('fast-action_loading');
            }
        });
    }
};
